import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AppState } from 'src/app/store/reducers';
import { GridUtils } from '../../utils/gridUtils';
import { AppSessionService } from '../app-session/app-session.service';
import { setAdvancedFilterQuery, setSimpleFilterQuery } from '../../utils/tableUtils';
import { FilterOperation } from 'src/app/models/custom-table/custom-table.model';
import {UserCreateDTO} from "../../../models/UserDetails/userCreateDTO";

const EMPTY_STRING = '';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private BASE_URL = this.appSession.baseUrl + '/api/v1/users';

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private appSession: AppSessionService
  ) { }

  public getUsers(paging?: any, filteringArgs?: any, sortingArgs?: any, advancedFilteringArgs?: any): Observable<any> {
    let headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0  || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append('sort', orderQuery);
    }

    return this.http.get(this.buildDataUrl(paging, filteringArgs, sortingArgs, headers, '?'), { headers });
  }

  updateUser(action): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const data = JSON.stringify(action.user);
    const url = `${this.appSession.baseUrl + '/api/v1/users'}/${action.user.username}`;

    return this.http.put(url, data, { headers });
  }

  getUser(action): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const username = localStorage.getItem('username');
    const url = `${this.appSession.baseUrl + '/api/v1/users'}/${action.user}`;

    return this.http.get(url, { headers });
  }

  getUserProfiles(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
    });

    const url = `${this.appSession.baseUrl + '/api/v1/users'}/profiles/translated`;

    return this.http.get(url, { headers });
  }

  changePassword(action): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const username = action.username;
    const data = JSON.stringify({
      currentPassword: action.currentPass,
      newPassword: action.newPass
    });
    const url = `${this.appSession.baseUrl + '/api/v1/users'}/${username}/password`;

    return this.http.put(url, data, { headers });
  }

  resetUserPassword(action): Observable<any> {
    const headers = new HttpHeaders({ 'Content-type': 'application/json' });
    const username = action.username;
    const data = JSON.stringify({ baseUrl: action.baseUrl });
    const url = `${this.appSession.baseUrl + '/api/v1/users'}/${username}/password/reset`;

    return this.http.put(url, data, { headers });
  }

  changeStatus(action): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const data = JSON.stringify({ codes: action.data.username, enabled: (action.data.enabled) });
    const url = `${this.appSession.baseUrl + '/api/v1/users'}/status`;

    return this.http.put(url, data, { headers });
  }

  createUser(user : UserCreateDTO): Observable<any> {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    const data = JSON.stringify(user);
    const url = `${this.appSession.baseUrl + '/api/v1/users'}`;

    return this.http.post(url, data, { headers });
  }

  // Grid filter helpers block

  private buildDataUrl(pagingArgs: any, filteringArgs: any, sortingArgs: any, header: HttpHeaders, path: string): string {
    // let baseQueryString = `${DATA_URL}?$count=true`;
    let baseQueryString = `${this.appSession.baseUrl + '/api/v1/users'}${path}`; // `${this.BASE_URL}/customers/search?`;
    let scrollingQuery = EMPTY_STRING;
    // let orderQuery = EMPTY_STRING;
    // let filterQuery = EMPTY_STRING;
    let query = EMPTY_STRING;


    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    // query += (orderQuery !== EMPTY_STRING) ? `&${orderQuery}` : EMPTY_STRING;
    // query += (filterQuery !== EMPTY_STRING) ? `&${filterQuery}` : EMPTY_STRING;
    query += (scrollingQuery !== EMPTY_STRING) ? `&${scrollingQuery}` : EMPTY_STRING;

    baseQueryString += query;

    return baseQueryString;
  }
}
